import styles from './overlays.module.css';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from '@mui/material';
import ModalClose from '@/components/ModalClose';

export default function VerifyEmailDialog({
    activeModal,
    onClose
}: Readonly<{
    activeModal: string;
    onClose: () => void;
}>) {

    return (
        <>
            <Dialog
                disablePortal
                className="verifyEmailModal"
                open={activeModal === 'userVerifying'}
                onClose={onClose}
            >
                <div className={styles.modalHeader}>
                    <DialogTitle className={styles.modalTitle}>
                        Verifying Your Email...
                    </DialogTitle>
                </div>
                <DialogContent>
                    <DialogContentText className={styles.modalDescription}>
                        Hang tight! We’re confirming your email address. This should only take a moment.
                    </DialogContentText>
                </DialogContent>
            </Dialog>
            <Dialog
                disablePortal
                className="verifyEmailModal"
                open={activeModal === 'userVerifyConfirmed'}
                onClose={onClose}
            >
                <div className={styles.modalHeader}>
                    <DialogTitle className={styles.modalTitle}>
                        Email Verified!
                    </DialogTitle>
                    <ModalClose onClick={onClose} />
                </div>
                <DialogContent>
                    <DialogContentText className={styles.modalDescription}>
                        Your email has been successfully verified. We will be in touch shortly to get you started.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        id="apply-form-cancel"
                        variant="contained"
                        onClick={onClose}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                disablePortal
                className="verifyEmailModal"
                open={activeModal === 'userVerifyFailed'}
                onClose={onClose}
            >
                <div className={styles.modalHeader}>
                    <DialogTitle className={styles.modalTitle}>
                        Verification Failed
                    </DialogTitle>
                    <ModalClose onClick={onClose} />
                </div>
                <DialogContent>
                    <DialogContentText className={styles.modalDescription}>
                        We couldn’t verify your email. Please contact our team for help.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        id="apply-form-cancel"
                        variant="contained"
                        onClick={onClose}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );

}